module.exports = __webpack_public_path__ + "static/img/imgEditStap.3c81a6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgEditStap.svg
// module id = 9Ytb
// module chunks = 3